import axios from "utils/axios";
import { API_BASE_URL, API_LOGIN } from "utils/constants";

const LOGIN_TYPES = {
  CUSTOMER_LOGIN: "CUSTOMER_LOGIN",
};

const login = (email: string, password: string) =>
  axios.post(`${API_BASE_URL}${API_LOGIN.BASE_URL}`, { email, password });
const customerLogin = (email: string, password: string) =>
  axios.post(`${API_BASE_URL}${API_LOGIN.BASE_URL}`, {
    email,
    password,
    type: LOGIN_TYPES.CUSTOMER_LOGIN,
  });

const loginAPI = {
  login,
  customerLogin,
};

export default loginAPI;
